import useBreakpoint from "use-breakpoint";

export const BREAKPOINTS = {
  xs: 0,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1440,
};

const useGetHeaderSize = () => {
  const { breakpoint } = useBreakpoint(BREAKPOINTS);

  const showFullHeader =
    breakpoint === null ? true : ["xl", "2xl"].includes(breakpoint);

  return { showFullHeader };
};

export default useGetHeaderSize;
